export type FallbackUiTranslation = {
  instruction: string;
  message: string;
  title: string;
};

export const fallbackUiTranslation: FallbackUiTranslation = {
  instruction:
    'Try the operation again. If the error persists, please email us: {{supportEmail}} with details.',
  message: 'We were unable to retrieve the data',
  title: 'Ooops! Something went wrong.',
};
